/*@ngInject*/
const CloseFormRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.closeForm = function (rootFormId) {
        let url = '/rest/Form/List?registrationIdentifier=RootFormList_' + rootFormId;

        return this.delete(url);
    };
};

angular.module('umFormViewer')
    .service('closeFormRepository', CloseFormRepository);
